import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('trades');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getTrades = createSelector(
  getState,
  (state: State) => state.data
);

